import { render, staticRenderFns } from "./JdpJobCandidates.vue?vue&type=template&id=5ba565b7&"
import script from "./JdpJobCandidates.vue?vue&type=script&lang=ts&"
export * from "./JdpJobCandidates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports